'use client';

import { QueryClientProvider as QueryClientProviderBase } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { getQueryClient } from './getQueryClient';

export const QueryClientProvider = ({ children }: { children: ReactNode }) => {
  const queryClient = getQueryClient();
  return <QueryClientProviderBase client={queryClient}>{children}</QueryClientProviderBase>;
};
